import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import API from "../api/axios";
import { useTheme } from "../context/ThemeContext";

const NAV_ITEMS = [
  { label: "Home", path: "/", icon: "🏠" },
  { label: "Products", path: "/products", icon: "📦" },
  { label: "Sales", path: "/sales", icon: "💰" },
  { label: "Expenses", path: "/expenses", icon: "💸" },
  { label: "Reports", path: "/reports", icon: "📊" },
  { label: "Settings", path: "/settings", icon: "⚙️" },
];

const HIDDEN_PATHS = [
  "/login", "/register", "/forgot-password",
  "/reset-password", "/join", "/admin",
];

export default function BottomNav() {
  const { theme } = useTheme();
  const [isMobile, setIsMobile] = useState(false);
  const [lowStockCount, setLowStockCount] = useState(0);
  const location = useLocation();

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;
    API.get("/products/alerts/low-stock")
      .then(res => setLowStockCount(res.data.length))
      .catch(() => {});
  }, []);

  if (!isMobile) return null;
  if (HIDDEN_PATHS.includes(location.pathname)) return null;

  return (
    <nav style={{
      position: "fixed", bottom: 0, left: 0, right: 0,
      background: theme.cardBg,
      borderTop: `1px solid ${theme.cardBorder}`,
      display: "flex", zIndex: 500, paddingBottom: "8px",
      boxShadow: "0 -2px 12px rgba(0,0,0,0.15)",
    }}>
      {NAV_ITEMS.map((item) => {
        const active = location.pathname === item.path;
        const showBadge = item.path === "/" && lowStockCount > 0;
        return (
          <Link key={item.path} to={item.path} style={{
            flex: 1, display: "flex", flexDirection: "column",
            alignItems: "center", justifyContent: "center",
            padding: "10px 4px 4px", textDecoration: "none", gap: "4px",
          }}>
            <div style={{ position: "relative", display: "inline-block" }}>
              <span style={{ fontSize: "20px", opacity: active ? 1 : 0.5 }}>
                {item.icon}
              </span>
              {showBadge && (
                <span style={{
                  position: "absolute", top: "-4px", right: "-6px",
                  background: "#e74c3c", color: "white",
                  borderRadius: "50%", width: "14px", height: "14px",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: "9px", fontWeight: "700",
                }}>
                  {lowStockCount}
                </span>
              )}
            </div>
            <span style={{
              fontSize: "10px",
              fontFamily: "inherit",
              color: active ? "#2ec4b6" : theme.textSecondary,
              fontWeight: active ? "700" : "400",
            }}>
              {item.label}
            </span>
          </Link>
        );
      })}
    </nav>
  );
}